module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"continue":"Продолжить","cancel":"Отмена","confirm":"Подтвердить"}}')
  delete Component.options._Ctor
}
